module.exports = __webpack_public_path__ + "img/collect-shape-1.af0313f5.png";